<template>
    <div class="body-panel">
        <div class="body-panel-control separator">
            <div class="control-block-left">
                <div class="flex">
                    <p class="btn-back margin-right-10">
                        <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                    </p>
                </div>
            </div>
            <div class="control-block-right">
                <div class="btns flex">
                    <button class="btn" @click="onExport()">
                        Экспорт
                    </button>
                </div>
            </div>
            <div class="body-panel-control-separator">
                <complex-filter ref="complexFilter"
                                :filters="filters"
                                :searchFunction="searchFunction"
                                :tableName="'[dbo].[FakeTable]'"
                                :withTableNameInClause="true"
                                @onFilterChange="onFilterChange"
                                :getByIdFilters="['User','OrderStatus']">
                </complex-filter>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page scroll-x-ok" @scroll="onScroll">
            <table class="table-view" cellspacing="0">
                <thead style="display: table-header-group !important;">
                    <tr class="heading">
                        <th>ФИО</th>
                        <th>Название курса</th>
                        <th>Дата сдачи</th>
                        <th>Дата выдачи сертификата</th>
                        <th>Дата скачивания сертификата</th>
                        <th>Управление сертификатом</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, i) of users">
                        <td class="string">{{ user.UserFIO }}</td>
                        <td class="string">{{ user.MaterialName }}</td>
                        <td class="datetime-2">
                            <p style="white-space:nowrap">{{ formatDateLong(user.StartDate) }}</p>
                        </td>
                        <td class="datetime-2">
                            <p style="white-space:nowrap">{{ formatDateLong(user.CreationDate) }}</p>
                        </td>
                        <td class="datetime-2">
                            <p style="white-space:nowrap">{{ formatDateLong(user.DownloadDate) }}</p>
                        </td>
                        <td>
                            <div class="btns flex">
                                <input type="file" class="file-upload-zone-btn" accept=".pdf"
                                       :id="'dropFiles' + i"
                                       :ref="'dropFiles' + i"
                                       :name="'dropFiles' + i"
                                       @change="onCertificateChange(user.SessionId, 'dropFiles' + i, user.UserId, user.MaterialName)" />
                                <button type="button" class="btn" v-if="user.CreationDate" @click="onCertificateDelete(user.SessionId)">Удалить</button>
                                <button type="button" class="btn" @click="onCertificateClick('dropFiles' + i)">{{ user.CreationDate ? 'Заменить' : 'Выбрать' }}</button>
                                <button type="button" class="btn" v-if="user.CreationDate" @click="onCertificateDownload(user.SessionId)">Посмотреть</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <vue-headful title="Выдача сертификатов" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import _ from 'lodash'
    import moment from 'moment'

    let backendApi = new BackendApi();

    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    const rowsPerPage = 50;

    let processFilter = function (filter) {
        let resultFilter = JSON.parse(JSON.stringify(filter));
        for (let item of resultFilter) {
            item[0] = item[0].replace("[dbo].[FakeTable].", "");
        }
        return resultFilter;
    };

    export default {
        name: "material-certificate",

        data() {
            return {
                users: [],
                totalUsers: 0,
                rewardTypes: [],
                canBeLoaded: true,
                isLoading: false,
                projectId: 0,
                folderId: null,
                page: 1,
                filter: null,
                filters: [
                    {
                        Value: 'UserFIO', Name: 'ФИО'
                    },
                    {
                        Value: 'MaterialName', Name: 'Название курса'
                    },
                    {
                        Value: 'StartDate', Name: 'Дата сдачи'
                    },
                    {
                        Value: 'CreationDate', Name: 'Дата выдачи'
                    },
                    {
                        Value: 'DownloadDate', Name: 'Дата скачивания'
                    }
                ]
            }
        },

        methods: {

            back() {
                this.$router.back();
            },

            loadUsers() {
                let vm = this;
                vm.folderId = vm.$route.query.folderId;
                vm.projectId = parseInt(vm.$route.params.projectId);
                let filterFormatted = '';
                if (vm.filter) {
                    filterFormatted = processFilter(vm.filter).map(x => {
                        return JSON.stringify(x)
                    });
                    if (filterFormatted == '')
                        filterFormatted = null;
                }

                return this.callApiWrapper(backendApi.materialCertificate((this.page - 1) * rowsPerPage, rowsPerPage, vm.projectId, vm.folderId, filterFormatted)).then(function (resp) {
                    if (resp.hasError) {
                        UI.toastr.error('Ошибка при при получении списка');
                    }
                    else {
                        if (resp.data && resp.data.list.length) {
                            vm.users.push(...resp.data.list);

                            vm.totalUsers = resp.data.totalUsers;
                        }
                        else {
                            vm.canBeLoaded = false;
                        }
                    }
                })
            },

            reload() {
                this.page = 1;
                this.canBeLoaded = true;
                this.users = [];
                this.loadUsers();
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                let filterFormatted = '';
                if (filters) {
                    filterFormatted = processFilter(filters).map(x => {
                        return JSON.stringify(x)
                    });
                }
                //console.info(tbName, columnName, this.projectId, search, filterFormatted, this.folderId);
                console.info('searchFunction search', search);
                this.callApiWrapper(backendApi.materialCertificateDistinctValues((searchPage - 1) * 100, 100, columnName, this.projectId, search, filterFormatted, this.folderId))
                    .then(function (resp) {
                        console.info(resp);
                        callback(resp.data);
                    })
            },

            onFilterChange(filter) {
                this.filter = filter;
                this.reload();
            },

            onCertificateClick(dropFiles) {
                let vm = this;
                vm.$refs[dropFiles][0].click();
            },

            onCertificateDelete(sessionId) {
                let vm = this;
                if (confirm('Удалить сертификат?')) {
                    UI.blockUI('dataContent', 'Удаление сертификата');
                    vm.callApiWrapper(backendApi.materialCertificateData(sessionId, null, null, true))
                        .then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при удалении сертификата');
                                console.info('error status', response.status)
                            }
                            else {
                                UI.toastr.success('Сертификата успешно удален');

                                vm.reload();
                            }
                        });
                }
            },

            onCertificateDownload(sessionId) {
                let vm = this;
                UI.blockUI('dataContent', 'Просмотр сертификата');
                vm.callApiWrapper(backendApi.materialCertificateDownload(sessionId, false))
                    .then(function (resp) {
                        UI.unblockUI('.dataContent');
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время скачивания');
                            console.info('error status', resp.status);
                        }
                        else {
                            console.info('resp.data', resp.data, resp);
                            //window.location.href = resp.data;
                            window.open(resp.data, '_blank');
                        }
                    });
            },

            onCertificateChange(sessionId, dropFiles, userId, materialName) {
                let vm = this;

                if (vm.$refs[dropFiles][0].files && vm.$refs[dropFiles][0].files[0]) {
                    if (vm.$refs[dropFiles][0].files[0].size > 50 * 1024 * 1024) {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                    } else {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            let fileData = e.target.result;
                            let fileName = vm.$refs[dropFiles][0].files[0].name;
                            //console.info(sessionId, dropFiles);
                            UI.blockUI('dataContent', 'Загрузка сертификата');
                            vm.callApiWrapper(backendApi.materialCertificateData(sessionId, fileData, fileName, false))
                                .then(function (response) {
                                    UI.unblockUI('.dataContent');
                                    if (response.hasError) {
                                        if (response.status === 2001) {
                                            UI.toastr.error('Неверный формат файла');
                                        }
                                        else {
                                            UI.toastr.error('Ошибка при загрузке сертификата');
                                        }
                                        console.info('error status', response.status)
                                    }
                                    else {
                                        UI.toastr.success('Сертификат успешно загружен');

                                        for (let user of vm.users) {
                                            if (user.SessionId === sessionId) {
                                                user.CreationDate = new Date();
                                            }
                                        }

                                        let certSettings = response.data;
                                        if (certSettings) {
                                            certSettings = JSON.parse(certSettings);
                                        }
                                        console.info(certSettings);
                                        if (certSettings && certSettings.Issuance !== 'undefined' && certSettings.Issuance.Actived) {
                                            let sendingTemplate = {
                                                Id: 0,
                                                Body: 'Сертификат в ' + materialName + ' доступен для скачивания',
                                                Name: 'Сертификат материала'
                                            };
                                            console.info(certSettings.Issuance.data.email, certSettings.Issuance.data.sms, sendingTemplate);
                                            if (certSettings.Issuance.data.email) {
                                                vm.onStartSending(sendingTemplate, userId, 2);
                                            }
                                            if (certSettings.Issuance.data.sms) {
                                                vm.onStartSending(sendingTemplate, userId, 1);
                                            }
                                        }
                                    }
                                });

                        };
                        reader.readAsDataURL(this.$refs[dropFiles][0].files[0]);
                    }

                }
            },

            onStartSending(sendingTemplate, userId, bulkSendingTypeId) {
                let vm = this;

                if (vm.activeTab === 'email' && !this.currentTemplate.Name) {
                    UI.toastr.error('Укажите тему письма');
                }
                else {
                    let notIncluded = [];
                    notIncluded.push(userId);
                    let smtpServerId = 1;
                    let roleId = null;
                    let dateSortEmpty = null;
                    let dateSortType = '';
                    let dateStart = new Date();
                    let dateEnd = new Date();
                    let allCurrentUsersSelected = false;

                    let filterFormatted = '';
                    //if (this.filter) {
                    //    filterFormatted = processFilter(this.filter).map(x => { return JSON.stringify(x) });
                    //}
                    let saveObj = {
                        TemplateId: sendingTemplate.Id,
                        NotIncluded: notIncluded,
                        Filter: filterFormatted,
                        ProjectId: this.projectId,
                        TemplateName: sendingTemplate.Name,
                        Body: sendingTemplate.Body,
                        BulkSendingTypeId: bulkSendingTypeId,
                        SmtpServerId: smtpServerId,
                        RoleId: roleId,
                        DateSortEmpty: dateSortEmpty,
                        DateSortType: dateSortType,
                        DateStart: moment(dateStart, 'DD.MM.YYYY').format(),
                        DateEnd: moment(dateEnd, 'DD.MM.YYYY').format(),
                        AllCurrentUsersSelected: allCurrentUsersSelected
                    };
                    this.callApiWrapper(backendApi.commonBulkSending(saveObj))
                        .then(function (response) {
                            if (response.hasError) {
                                if (response.status === 401) {
                                    UI.toastr.error('Недостаточно прав для отправки уведомления');
                                }
                                else {
                                    UI.toastr.error('Ошибка при создании рассылки');
                                }
                            } else {
                                UI.toastr.success('Успешно создано');
                                //vm.onTabChange('history');
                            }

                            UI.unblockUI('#app');
                        });
                }
            },

            onScroll(e) {
                let vm = this;
                if (!vm.isLoading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        vm.loadUsers();
                    }
                }
            },

            onExport() {
                let vm = this;

                let projectId = vm.projectId;
                let filterFormatted = '';
                if (vm.filter) {
                    filterFormatted = processFilter(vm.filter).map(x => {
                        return JSON.stringify(x)
                    });
                }

                UI.blockUI('#app');
                this.callApiWrapper(backendApi.materialCertificateExport(projectId, vm.folderId, filterFormatted))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                            console.info('resp', resp);
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, "Пользователи.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                            }
                        }
                        UI.unblockUI('#app');
                    });
            }
        },


        mounted() {
            let vm = this;
            UI.blockUI('.page-content', 'Загрузка...');
            vm.loadUsers().then(() => {
                UI.unblockUI('.page-content');
            });
            //vm.$refs.complexFilter.applyFilter();
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Content/src/views/details/MaterialCertificate.vue